import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { HtmlBlockConfig } from '@front-platform/content-builder';
import { htmlBlockResolveConfig } from '@front-platform/content-builder';
import { Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { createVariablesRecord } from '@core/models/block.model';
import {
  BlockCommon,
  BlockCommonDataInterface,
  BlockVariables,
} from '@shared/interfaces/block.interface';
import { ContentBuilderVariablesService } from '@shared/utils/content-builder-variables/content-builder-variables.service';
import { switchMap } from 'rxjs';
export interface HtmlBlockRuntimeConfig {
  'common'?: BlockCommon;
}

export type HtmlBlockConfigInput = Partial<
  Omit<HtmlBlockConfig, keyof HtmlBlockRuntimeConfig> & HtmlBlockRuntimeConfig
>;
export type HtmlBlockResolvedConfig = Omit<HtmlBlockConfig, keyof HtmlBlockRuntimeConfig> &
  Partial<HtmlBlockRuntimeConfig>;
export interface HtmlBlockContract extends ConfigComponentContract<
  HtmlBlockConfigInput,
  HtmlBlockResolvedConfig
> {}

@Component({
  selector: 'app-html-block',
  templateUrl: './html-block.component.html',
  template: ``,
  standalone: false,
})
export class HtmlBlockComponent implements BlockCommonDataInterface, HtmlBlockContract {
  readonly config = input<HtmlBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<HtmlBlockConfig, HtmlBlockRuntimeConfig>(
    htmlBlockResolveConfig,
    () => ({ config: this.config() }),
  );
  private readonly contentBuilderVariablesService = inject(ContentBuilderVariablesService);
  protected readonly blockVariables = computed(() => this.common()?.variables ?? []);

  readonly html = computed(() => this.resolvedConfig()['html'] as unknown as string);

  readonly common = computed(() => this.resolvedConfig()['common'] as unknown as BlockCommon);
  private readonly inputs = computed(() => ({
    html: this.html(),
    variables: this.blockVariables(),
  }));

  protected readonly parsedHtml = toSignal(
    toObservable(this.inputs).pipe(
      switchMap(({ html, variables }) => {
        return this.parseContentBuilderVariables$(html ?? '', variables);
      }),
    ),
  );

  protected readonly parseContentBuilderVariables$ = (html: string, variables: BlockVariables) => {
    return this.contentBuilderVariablesService.parseContentBuilderString$(
      html,
      createVariablesRecord(variables),
    );
  };
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(HtmlBlockComponent, { 'keyAliases': {} });
